// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useEffect } from 'react';
import { screenerApi } from '@shared/data-access/api/ai/screener-api';
import { useHandleApiErrors } from '@advisor-app/hooks';
import { useDebounce } from '@shared/ui-kit/hooks';

export const useSearchUniverse = (searchText: string) => {
  const handleApiErrors = useHandleApiErrors();
  const debounceValue = useDebounce(searchText, 200);

  const {
    data: universes = [],
    isLoading,
    error,
  } = screenerApi.useGetStockUniverseSearchQuery(
    { search_text: debounceValue },
    {
      skip: !debounceValue,
    },
  );

  useEffect(() => {
    if (error) {
      handleApiErrors(error as any);
    }
  }, [error, handleApiErrors]);

  return { isLoading, universes };
};
